// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mKrDq","textarea":"styles_textarea__13Bol"};